import React from 'react';
import IconBase, { IconBaseProps } from '../IconBase';

export default function CheckIcon({ size, viewBox = '0 0 8 6.22', ...others }: IconBaseProps) {
  return (
    <IconBase size={size} viewBox={viewBox} {...others}>
      <path
        d="M7.82.22a.7.7 0 010 1l-5.16 5L.21 3.86a.71.71 0 010-1 .66.66 0 01.94 0l1.48 1.47L6.88.19a.65.65 0 01.94.03z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </IconBase>
  );
}
